module.exports = __webpack_public_path__ + "static/media/web_2011.0377f4a0.jpg";